module.exports = __webpack_public_path__ + "static/media/youtube-cover.2daae225.jpg";